import { type RouteLocation } from 'vue-router'
import { useStorage } from '@vueuse/core'
import { handleAuthRedirects } from '@core/router/handleAuthRedirects'
import router from '@core/router'

const storage = useStorage('cluber', {
  auth: { token: '' },
}, localStorage)

// ***
// AVOID REFRESHING TOKEN
//

export function isRefreshTokenForbidden(params?: {
  routeTo?: RouteLocation,
  routeFrom?: RouteLocation,
}) {
  const currentRoute = router.currentRoute.value
  const routeTo = params?.routeTo ?? currentRoute
  const routeFrom = params?.routeFrom

  const scenarios = {
    isNavigatingBetweenLegacyRoutes: !routeFrom && currentRoute.fullPath === '/' && !Object.keys(currentRoute.query || {}).length,
    isPublicRoute: routeTo?.meta.isPublic,
    isAuthRoute: window.location.pathname.includes('/auth/'),
    noTokenAvailable: !storage.value?.auth.token,
  }

  if (scenarios.isNavigatingBetweenLegacyRoutes) return false

  if (scenarios.isAuthRoute) return true

  if (scenarios.isPublicRoute) return true

  if (scenarios.noTokenAvailable && !scenarios.isAuthRoute) {
    if (!scenarios.isPublicRoute) {
      handleAuthRedirects()
    }
    return true
  }

  return Object.values(scenarios).some(Boolean)
}
